









































import { Vue, Component, Prop } from 'vue-property-decorator';
import AMSformTable from '../../../components/AMSformTable.vue';
import AMSProduct from '../../../components/AMSProductCategorySelector.vue';
import AMSProductImg from '../../../components/AMSProductImg.vue';
import request from '@/utils/request';
import Utils from '@/utils/utils';
import AMSBrandSelector from '@/components/AMSBrandSelector.vue';
import AMSBreadcrumb from '@/components/AMSBreadcrumb.vue';
import { getModuleName } from '@/utils/utils';
interface Form {
  productFilter?: string;
  productCategoryId?: string;
  brandId?: string;
  lessThanOrEqualStockWarning?: boolean;
  greateThenStockWarning?: boolean;
  zeroStockQuantity?: boolean;
  isUnderShipment?: boolean;
}
@Component({
  components: {
    'ams-formtable': AMSformTable,
    'ams-product': AMSProduct,
    'ams-brand-selector': AMSBrandSelector,
    'ams-breadcrumb': AMSBreadcrumb
  }
})
export default class ProductStock extends Vue {
  breadcrumbsItems = [
    {
      text: '库存管理',
      disabled: false,
      href: '/productStock'
    },
    {
      text: '商品库存',
      disabled: true
    }
  ];
  api: string = '/api/Product/stock/list';
  rules = { name: [] };
  form: Form = {};
  initForm() {
    this.form = { brandId: '', productFilter: '', greateThenStockWarning: true, lessThanOrEqualStockWarning: true, zeroStockQuantity: true, isUnderShipment: true };
  }
  categoryList: Array<any> = [];
  headers = [
    // { text: '编号', value: 'serialNumber', sortable: false, width: 100, align: 'left' },
    {
      text: '商品',
      value: 'name',
      sortable: false,
      render: (h: Function, param: any) => {
        return h(AMSProductImg, {
          props: {
            isShowNumber: true,
            product: param.row,
            pictureWidth: 40,
            pictureHeight: 40
          }
        });
      },
      width: 100,
      align: 'left'
    },
    { text: '容量', value: 'capacity', width: 90, align: 'right' },
    {
      text: '库存数|箱',
      value: 'stockQuantity',
      isToolTip: true,
      toolTip: ['库存数=不包含已配货待发货数的库存数量'],
      sortable: true,
      render: (h: Function, param: any) => {
        let content: Array<string> = [];

        if (param.row.stockQuantity !== null) {
          content.push(param.row.stockQuantity.toString());
        }
        if (param.row.stockPackingNumber !== null) {
          content.push(param.row.stockPackingNumber.toString());
        }
        return h('div', content.join(' | '));
      },
      width: 160,
      align: 'right'
    },
    { text: '冻结库存数', value: 'lockedStockQuantity', sortable: false, width: 100, align: 'right', toolTip: ['冻结库存数=已配货待发货数'], isToolTip: true },
    /*{ text: '累计入库数', value: 'inStockCount', sortable: false, width: 100, align: 'right' },
    { text: '累计出库数', value: 'outStockCount', sortable: false, width: 100, align: 'right' },*/
    {
      toolTip: ['预警差值=库存预警值-库存数', '欠货=未配货-库存数，无欠货时，欠货=0'],
      isToolTip: true,
      text: '参考补货',
      value: 'earlyWarningValue',
      sortable: false,
      class: 'font-red',
      render: (h: Function, param: any) => {
        let content = [];
        if (param.row.earlyWarningValue !== null) {
          content.push(h('div', '预警差值：' + param.row.earlyWarningValue.toString()));
        }
        if (param.row.underShipmentQuantity !== null) {
          content.push(h('div', { style: { color: param.row.underShipmentQuantity > 0 ? 'red' : 'black' } }, '欠货：' + param.row.underShipmentQuantity.toString()));
        }
        return h('div', content);
      },
      width: 140,
      align: 'right'
    },
    {
      toolTip: ['未发货数=未配货数+已配货待发货数'],
      isToolTip: true,
      text: '未发货数',
      value: 'unshippedQuantity',
      width: 140,
      align: 'right'
    },
    {
      text: '操作',
      value: 'actions',
      sortable: false,
      isDetail: [
        {
          routerName: 'stockDetail',
          text: '查看明细',
          color: '#1ABC9C',
          isParams: true,
          isShowBtn: (row: any) => {
            return Utils.isPermission('InventoryManager.StockDetail');
          }
        }
      ],
      width: 120,
      align: 'center'
    }
  ];
  created() {
    // this.initForm();
    if (JSON.parse(localStorage.getItem(`${getModuleName(this.$route.name as string)}_search`) as string)) {
      this.form = JSON.parse(localStorage.getItem(`${getModuleName(this.$route.name as string)}_search`) as string);
    }
  }
}
